import React from "react";
import { usePurchaseDrModel } from "../purchaseDrModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import useGlobalModel from "@/model/globalModel";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = usePurchaseDrModel();
    const { getSelectedDictOne } = useDictModel(() => []);
    const { shopAndOrg: { shopType }, allShopDs } = useGlobalModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "调拨单号",
            fieldName: "code"
        }, {
            type: SearchTypeEnum.Input,
            placeholder: "调出单号",
            fieldName: "transferOutCode"
        }, {
            type: SearchTypeEnum.Input,
            placeholder: "调入单号",
            fieldName: "transferInCode"
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "状态",
            fieldName: "status",
            mode: "multiple",
            options: getSelectedDictOne(DictCodeEnmu.TRANSFER_STATUS)
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "调出站点",
            fieldName: "outShopId",
            options: allShopDs,
            disabled: shopType === 0 ? false : true
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "调入站点",
            fieldName: "shopId",
            options: allShopDs,
            disabled: shopType === 0 ? false : true
        },
    ]
    const searchMoreFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "备注",
            fieldName: "inNote"
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            rangePickerFieldName: ["startTime", "endTime"],
            placeholder: ["制单起始日期", "制单结束日期"],
            format: "YYYY-MM-DD",
        }, {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            rangePickerFieldName: ["inStartTime", "inEndTime"],
            placeholder: ["调入起始日期", "调入结束日期"],
            format: "YYYY-MM-DD",
            alloc: true,
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            rangePickerFieldName: ["startTime", "endTime"],
            placeholder: ["请调起始日期", "请调结束日期"],
            format: "YYYY-MM-DD",
            alloc: true,
        }
    ]
    return (
        <YhPageHeader
            title="调入单"
            size="small"
            searchMoreFields={searchMoreFields}
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}